import { createFileRoute } from '@tanstack/react-router';

import { fileLinesSearch, loadWalletMessages, loadWalletScreens, walletInstructionLinesScreen } from '@/modules/wallet/route';
import { lazyScreen } from '@/shared/screen';

// Transações do arquivo remessa (`router.tsx:1392-1396`), irmã do detalhe e sem menu.
export const Route = createFileRoute('/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa')({
  validateSearch: fileLinesSearch,
  staticData: { screen: walletInstructionLinesScreen },
  loader: loadWalletMessages,
  component: lazyScreen(loadWalletScreens, 'WalletInstructionLinesScreen'),
});
